import { Field } from 'redux-form';
import StarRatingInput from './StarRating';

const StarRating = (props) => {
  return ( 
    <div>
      <Field
        {...props}
        component={StarRatingInput}
      />
    </div>
  );
}

export default StarRating;